import { render, staticRenderFns } from "./FiltroReservaCartaoMargens.vue?vue&type=template&id=1920bf1d&"
import script from "./FiltroReservaCartaoMargens.vue?vue&type=script&lang=js&"
export * from "./FiltroReservaCartaoMargens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports